module.exports = __webpack_public_path__ + "static/media/v4.b4ff762e.png";